import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class LandingSettings extends BaseModel {
  static override constructorName = 'LandingSettings'

  'is_hide_header': boolean = false
  'is_hide_footer': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.is_hide_header = Boolean(Number(data.is_hide_header))
      this.is_hide_footer = Boolean(Number(data.is_hide_footer))
    }
  }
}
